var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"is-size-3"},[_vm._v(_vm._s(_vm.companyName))]),_c('div',[_vm._v(_vm._s(_vm.companyAddress))]),_c('div',[_vm._v("Telp. "+_vm._s(_vm.companyPhone))])])
}
var staticRenderFns = []

export { render, staticRenderFns }